import React from 'react';

const About = () => (
  <div style={{ padding: '0 15px' }}>
    <p>BIWAPP ist die kostenlose Smartphone-App zur Warnung und Information der Bevölkerung.</p>
    <p>
      Aktuelle Informationen und Katastrophenmeldungen für Ihre ausgewählten Orte und den gewählten
      Umkreis erhalten Sie direkt auf Ihr Smartphone.
    </p>
    <p>
      Sie können individuell festlegen, über welche Themen Sie aktiv informiert werden möchten (z.B.
      Schulausfälle, Verkehrsunfälle, Feuer, Hochwasser, Bombenentschärfung, allgemeine Warnungen
      u.a.).
    </p>
    <p>
      Die Meldungen und Katastrophenwarnungen werden direkt von den offiziell zuständigen
      Institutionen wie Katastrophenschutzbehörden, Kommunen und kreisfreien Städten sowie deren
      Leitstellen versendet.
    </p>
    <p>
      BIWAPP ersetzt nicht die Anweisungen von Behörden, Polizei oder anderen Einsatzkräften vor
      Ort.
    </p>
    <p>
      Für die Nutzung von BIWAPP und dem Empfang der Informationen ist eine Datenverbindung (WLAN
      oder mobil) erforderlich. Hierdurch können Kosten bei Ihrem jeweiligen Dienstanbieter
      entstehen.
    </p>
    <p>
      Zur Nutzung der Ortungsfunktion müssen die Ortungsdienste auf Ihrem Smartphone aktiviert sein.
    </p>
    <p>
      Weitere Informationen über BIWAPP erhalten Sie unter{' '}
      <a href="https://www.biwapp.de" target="_blank" rel="noopener noreferrer">
        www.biwapp.de
      </a>
    </p>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/js/routes/Information/About.js